import { render, staticRenderFns } from "./CustomerReceiveList.vue?vue&type=template&id=26a3c2e4"
import script from "./CustomerReceiveList.vue?vue&type=script&lang=js"
export * from "./CustomerReceiveList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports